import styled from 'styled-components';

import type { ThemeSpaceType } from 'src/styles/theme';

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: calc(100vh - 8rem);
`;

export const ContentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 58rem;
  width: 100%;
  padding: ${props => props.theme.space['10.0']} ${props => props.theme.space['2.0']}
    ${props => props.theme.space['14.4']};
  flex: 1 1 auto;
  ${props => props.theme.mediaQueries.mediumDown} {
    padding: ${props => props.theme.space.s7} ${props => props.theme.space.s7} ${props => props.theme.space['14.4']};
    max-width: none;
  }
`;

export const CopyLine = styled.p<{ marginBottom?: ThemeSpaceType }>`
  margin-bottom: ${props =>
    props.marginBottom ? props.theme.space[props.marginBottom] : props.theme.space.s3} !important;
`;

export const LastLine = styled.p`
  margin-bottom: ${props => props.theme.space.s7} !important;
`;

export const Title = styled.h3`
  font-size: ${props => props.theme.fontSizes.displayXL} !important;
  padding-top: 0 !important;
`;

export const FooterRow = styled.div`
  ${props => props.theme.mediaQueries.mediumDown} {
    padding: ${props => props.theme.space.none} ${props => props.theme.space.s7} ${props => props.theme.space.s7};
  }
  padding: ${props => props.theme.space.none} ${props => props.theme.space.s7} ${props => props.theme.space.s5};
`;
